import { extendTheme, ModalOverlay } from "@chakra-ui/react";

const theme = extendTheme({
  textStyles: {
    notoH40: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "40px",
      fontWeight: "bold",
      lineHeight: "48px",
    },
    notoH32: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "32px",
      fontWeight: "bold",
      lineHeight: "40px",
    },
    notoH24: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "24px",
      fontWeight: "bold",
      lineHeight: "32px",
    },
    notoH20: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "20px",
      fontWeight: "bold",
      lineHeight: "28px",
    },
    notoH16: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "16px",
      fontWeight: "bold",
      lineHeight: "24px",
    },
    notoH16D: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "16px",
      fontWeight: "bold",
      lineHeight: "24px",
      textDecoration: "underline",
    },
    notoH14: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "20px",
    },
    notoH14D: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "20px",
      textDecoration: "underline",
    },
    notoH12: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "12px",
      fontWeight: "bold",
      lineHeight: "16px",
    },
    notoP24: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "24px",
      fontWeight: "normal",
      lineHeight: "32px",
    },
    notoP20: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "20px",
      fontWeight: "normal",
      lineHeight: "28px",
    },
    notoP16: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "16px",
      fontWeight: "normal",
      lineHeight: "24px",
    },
    notoP16D: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "16px",
      fontWeight: "normal",
      lineHeight: "24px",
      textDecoration: "underline",
    },
    notoP14: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "14px",
      fontWeight: "normal",
      lineHeight: "20px",
    },
    notoP14D: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "14px",
      fontWeight: "normal",
      lineHeight: "20px",
      textDecoration: "underline",
    },
    notoP12: {
      fontFamily: "Noto Sans TC, sans-serif",
      fontSize: "12px",
      fontWeight: "normal",
      lineHeight: "16px",
    },
    poppinsH24: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "24px",
      fontWeight: "bold",
      lineHeight: "32px",
    },
    poppinsH20: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "20px",
      fontWeight: "bold",
      lineHeight: "28px",
    },
    poppinsH16: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "16px",
      fontWeight: "bold",
      lineHeight: "24px",
    },
    poppinsH14: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "20px",
    },
    poppinsH12: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "12px",
      fontWeight: "bold",
      lineHeight: "16px",
    },
    poppinsP16: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "16px",
      fontWeight: "normal",
      lineHeight: "24px",
    },
    poppinsP14: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "14px",
      fontWeight: "normal",
      lineHeight: "20px",
    },
    poppinsP12: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "12px",
      fontWeight: "normal",
      lineHeight: "16px",
    },
  },
  fonts: {
    heading: "Noto Sans TC, sans-serif",
    body: "Noto Sans TC, sans-serif",
  },
  components: {
    Radio: {
      baseStyle: {
        control: {
          borderColor: "#28292B",
          _checked: {
            bg: "#28292B",
            borderColor: "#28292B",
            boxShadow: "none",
          },
          _focus: {
            boxShadow: "none",
          },
        },
      },
    },
  },
});

export default theme;
